import { faBasketShopping, faImageSlash, faWeightScale } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { tss } from 'tss-react';

import COLOR from 'enums/COLOR';
import useCurrency from 'hooks/redux/useCurrency';
import useTranslation from 'hooks/useTranslation';
import { Product, renderWeight } from 'types/ShoppingCart/Product';

interface IProps {
	product: Product.Type;
}

const fadeAnimation = `
@keyframes fadeOp {
  0% { opacity: 0; }
  100% { opacity: 0.5; }
}
`;

const ProductHeader = ({ product }: IProps) => {
	const { classes } = useStyles();
	const { tl } = useTranslation();
	const currency = useCurrency();
	const [imageError, setImageError] = useState(false);

	return (
		<>
			<div className={classes.container}>
				<style>{fadeAnimation}</style>
				{product.imageUrl && product.imageUrl.length > 0 && !imageError ? (
					<img
						src={product.imageUrl}
						style={{
							maxHeight: '2rem',
							maxWidth: '2rem',
						}}
						alt="Product"
						onError={() => setImageError(true)}
					/>
				) : (
					<div
						style={{
							minHeight: '2rem',
							minWidth: '2rem',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							background: '#f0f0f0',
							borderRadius: '0.3rem',
						}}
					>
						<FontAwesomeIcon
							icon={faImageSlash}
							style={{
								opacity: 0,
								animation: 'fadeOp 2s linear infinite alternate',
							}}
						/>
					</div>
				)}
			</div>
			<div className="row w-100 d-flex align-items-center">
				<div className="col-md-6 d-flex align-items-center">
					<span style={{ fontWeight: '500' }}>{tl(product.ingredient.name)}</span>
				</div>

				<div
					className="col-md-2 d-flex align-items-center"
					style={{ borderLeft: '1px solid' }}
				>
					<span style={{ fontWeight: '500' }}>
						<FontAwesomeIcon
							style={{
								marginRight: '2px',
								opacity: '0.6',
							}}
							icon={faWeightScale}
						></FontAwesomeIcon>{' '}
						{Product.renderWeight(product.weight, product, true)}
					</span>
				</div>
				<div
					className="col-md-2 d-flex align-items-center"
					style={{ borderLeft: '1px solid' }}
				>
					<span style={{ fontWeight: '500' }}>
						<FontAwesomeIcon
							style={{
								marginRight: '2px',
								opacity: '0.6',
							}}
							icon={faBasketShopping}
						></FontAwesomeIcon>{' '}
						{Product.getQuantity(product)}&times;{' '}
						{renderWeight(product.size, product, true)}
					</span>
				</div>
				<div
					className="col-md-2 d-flex align-items-center justify-content-between"
					style={{ borderLeft: '1px solid' }}
				>
					<span style={{ fontWeight: '500' }}>
						{currency} {Product.getFullPrice(product).toFixed(2)}
					</span>
				</div>
			</div>
		</>
	);
};

export default ProductHeader;

export const useStyles = tss.create({
	container: {
		width: '2rem',
		paddingRight: '1rem',
		marginRight: '1rem',
		height: '2rem',
		backgroundColor: 'white',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRight: '1px solid #ccc',
	},
	img: {
		width: '40px',
		height: '40px',
	},
	count: {
		backgroundColor: COLOR.PRIMARY,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: '1.6rem',
		minWidth: '1.6rem',
		padding: '0px 8px',
		fontSize: '0.8em',
		color: 'white',
	},
});
